import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import { IGameModeChangedData } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";

/**
 * Base interface for background config
 */
export interface IBackgroundConfig {
    readonly layer:string;
} 

/**
 * Base class for a background view. Initializes with listener and handler for GameModeEvent.CHANGE_MODE.
 * So onChangeBackground is called when it's time to change background to the new current mode.
 */
export abstract class Background extends BaseView {

    protected readonly _layer:ScalableLayer;
    protected _currentMode:string;

    constructor(config:IBackgroundConfig, resourceGroup?:ResourcesGroupName) {
        super(resourceGroup);
        this._layer = StageManager.getLayer(config.layer);
    }

    /**
     * Add listener for GameModeEvent.CHANGE_MODE
     */
    protected addEventListeners():void {
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeBackground(event.params[0]));
    }

    /**
     * Adds background to the layer specified in the config.
     */
    protected initAnimations():void {
        this._layer.addChild(this);
    }

    /**
     * Handler for GameModeEvent.CHANGE_MODE. Triggered when it's time to change background. Function sets
     * this._currentMode the new mode if it's different and return true.
     * @param data Event data
     * @returns {boolean} Returns true if the new game mode is different for the current one, I.e. the game mode has
     *     changed.
     */
    protected onChangeBackground(data:IGameModeChangedData):boolean {
        if(data.newMode === this._currentMode) {
            return false;
        }
        this._currentMode = data.newMode;
        return true
    }
}
